import React from 'react';
import Portfolio from '../Hero/Portfolio'
import Header from "../Header/Header";
import Fade from 'react-reveal';
import Footer from '../Footer/Footer';
import loadinglogo from '../images/logo-gif.gif';
import ai from '../images/ai.png';
import digitalMarketing from '../images/digital-marketing.png';
import vas from '../images/vas.png';
import games from '../images/games.png';
import ux from '../images/ui_ux.png';
import mobileMoney from '../images/mobile-money.png';
import machineLearning from '../images/machine-learning.png';
import omniChannel from '../images/omni-channel.png';
import Particles from 'react-particles-js';
import { Link } from 'react-scroll';
import Graph from 'react-graph-vis';


const omniText = 
    <div className="omni-texts">
        <h2>Omnichannel</h2>
        <p>Online and universal customer experience across all channels: USSD, SMS, WEB, MOBILE</p>
    </div>;
  const gameText = 
    <div className="omni-texts">
      <h2>Online games</h2>
      <p>Lotteries, games of chance, sports betting, horse racing</p>
    </div>;
    const vasText = 
     <div className="omni-texts">
       <h2>VAS</h2>
       <p>Subscription based premium content delivery services</p>
     </div>;  
  const digitalText =
     <div className="omni-texts">
       <h2>Digital Marketing</h2>
       <p>Reach and engage customers through targeted campaigns</p>
     </div>;  
     const aiText =
     <div className="omni-texts">
       <h2>AI</h2>
       <p>AI driven games, campaigns and promotions </p>
     </div>;
     const uxText =
     <div className="omni-texts">
       <h2>UI/UX</h2>
       <p>Continuously improving the customer journey </p>
     </div>;
      const mmText =
     <div className="omni-texts">
       <h2>Mobile Money</h2>
       <p>Online gaming wallet, mobile money deposits and withdrawals </p>
     </div>;
     const mltext =
     <div className="omni-texts">
       <h2>Machine Learning</h2>
       <p>Learn, build and improve through technology </p>
     </div>;
const textArray = [omniText, uxText, digitalText, aiText, mltext, gameText, mmText, vasText ];  

class HomePage extends React.Component{
    constructor() {
        super();
        this.state = {
          WindowSize : window.innerWidth,
          loading: true,
          textIdx: 0,
          show: false 
        }
        this.handleResize = this.handleResize.bind(this);
      }
    
    componentDidMount() {
      // window.addEventListener("resize", this.handleResize);
      this.timeout = setInterval(() => {
        this.setState({ show: !this.state.show });
      }, 4000);
        if (this.state.loading) {
          this.changeContent = setTimeout(() => { 
            this.setState(() => ({loading: false}))
          }, 3000);
        };
        this.timeout = setInterval(() => {
          let currentIdx = this.state.textIdx;
          this.setState({ textIdx: currentIdx + 1 });
        }, 8000);
    }
    componentWillUnmount() {
      clearInterval(this.timeout);
      window.addEventListener("resize", null);
    }
    
    handleResize(WindowSize, event) {
        this.setState({WindowSize: window.innerWidth})
    }
    
     render() {
        let textThatChanges = textArray[this.state.textIdx % textArray.length];
        var graph = {
            nodes: [
                {id: 'omni-channel', color:'gold', image:omniChannel, shape:'image', size:'120', url: 'omni-channel'},
                {id: 'machineLearning',color:'gold', image:machineLearning, shape:'image', size:'90'},
                {id: 'ux',color:'gold', image:ux, shape:'image', size:'60'},
                {id: 'digitalMarketing',color:'gold', image:digitalMarketing, shape:'image', size:'60'},
                {id: 'ai',color:'gold', image:ai, shape:'image', size:'60'},
                {id: 'mobileMoney',color:'gold', image:mobileMoney, shape:'image', size:'60'},
                {id: 'games',color:'gold', image:games, shape:'image', size:'60'},
                {id: 'vas',color:'gold', image:vas, shape:'image', size:'60'}
            ],
            edges: [
                {from: 'omni-channel', to: "machineLearning", length: "220"},
                {from: 'digitalMarketing', to: 'ux', length: "150"},
                {from: 'omni-channel', to: 'digitalMarketing', length: "220"},
                {from: 'omni-channel', to: 'ai', length: "210"},
                {from: 'omni-channel', to: 'vas', length: "210"},
                {from: 'vas', to: 'games', length: "150"},
                {from: 'omni-channel', to: 'mobileMoney', length: "210"}
            ]
        };
   
 
  var options = {
    autoResize: true,
    height: '100%',
    width: '100%',
    physics: {
      barnesHut: {
        avoidOverlap: 1
      },
      minVelocity: 0.75
    },
    layout: {
      hierarchical: {
        enabled:false,
        levelSeparation: 950,
        nodeSpacing: 900,
        treeSpacing: 900,
      }
    },
    edges: {
        color: "#000000"
    },
    interaction:{
      dragNodes:true,
      dragView: false,
      hideEdgesOnDrag: false,
      hideNodesOnDrag: false,
      hover: true,
      hoverConnectedEdges: true,
      multiselect: false,
      navigationButtons: true,
      selectable: true,
      selectConnectedEdges: true,
      tooltipDelay: 10,
      zoomView: false,
    }
    
  }
  
  var events = {
      select: function(event) {
          var { nodes } = event;
          let node = nodes[0];
          let url = '';
          if (node === 'omni-channel') {
            url = '/omni-channel/';
          }
          if (node === 'machineLearning' || node === 'ai') {
            url = '/data-innovation/';
          }
          if (node === 'mobileMoney' || node === 'games' || node === 'vas') {
            url = '/products/';
          }
          if (node === 'ux' || node === 'digitalMarketing') {
            url = '/demographics/';
          }
          window.location = url;
          console.log(nodes);
      },
      // hoverNode : function(event) {
      //   console.log(event);
      // }
  }
    var particleNb = 50;
    if (this.state.WindowSize < 991) {
        particleNb = 10;
    }

    const params = {
            "particles": {
                "number": {
                  "value": particleNb,
                  "density": {
                    "enable": false,
                    "value_area": 8233.02740709759
                  }
                },
                "color": {
                  "value": "#ffffff"
                },
                "shape": {
                  "type": "circle",
                  "stroke": {
                    "width": 0,
                    "color": "#000000"
                  },
                  "polygon": {
                    "nb_sides": 5
                  },
                },
                "opacity": {
                  "value": 0.5,
                  "random": false,
                  "anim": {
                    "enable": false,
                    "speed": 1,
                    "opacity_min": 0.1,
                    "sync": false
                  }
                },
                "size": {
                  "value": 3,
                  "random": false,
                  "anim": {
                    "enable": false,
                    "speed": 20,
                    "size_min": 0.1,
                    "sync": false
                  }
                },
                "line_linked": {
                  "enable": true,
                  "distance": 144.30708547789706,
                  "color": "#ffffff",
                  "opacity": 0.4,
                  "width": 1
                },
                "move": {
                  "enable": true,
                  "speed": 1,
                  "direction": "right",
                  "random": false,
                  "straight": false,
                  "out_mode": "out",
                  "bounce": false,
                  "attract": {
                    "enable": false,
                    "rotateX": 600,
                    "rotateY": 1200
                  }
                }
              },
              "interactivity": {
                "detect_on": "canvas",
                "events": {
                  "onhover": {
                    "enable": false,
                    "mode": "repulse"
                  },
                  "onclick": {
                    "enable": false,
                    "mode": "push"
                  },
                  "resize": true
                },
                "modes": {
                  "grab": {
                    "distance": 400,
                    "line_linked": {
                      "opacity": 1
                    }
                  },
                  "bubble": {
                    "distance": 400,
                    "size": 40,
                    "duration": 2,
                    "opacity": 8,
                    "speed": 3
                  },
                  "repulse": {
                    "distance": 200,
                    "duration": 0.4
                  },
                  "push": {
                    "particles_nb": 4
                  },
                  "remove": {
                    "particles_nb": 2
                  }
                }
              },
              "retina_detect": true
        }
        let div;
        let hiddenClass = '';
        if (this.state.loading === true) {
            hiddenClass = 'hidden';
          div =
          <div className="platform"> 
            <img className="loading-image" width="400" src={loadinglogo}/>
          </div>
        } else {
            hiddenClass = '';
            div =
            <div className="platform">
                <Graph graph={graph} options={options} events={events} />
                <div className="about-moobifun">
                <h2>Get to know us</h2>
                <p>
                    Moobifun is a French Design-Build-Operate technology firm, providing turnkey solutions to mobile markets since 2009.
                </p>
                </div>
                <div className="position-container">
                <Fade left  when={this.state.show}>
                {textThatChanges}
                </Fade>
                </div>
            </div>
            
        } 
       return (
        <Fade delay={1000}>
        <div className={"homepage " + hiddenClass}>
        
            <Header />
            <div className="hp-section hero" id="hero">
                <Particles className="particle firstParticle"
                    params={params}
                />
                {div}
                <Particles className="particle secondParticle"
                    params={params}
                />
                <Link activeclass="active"className="section-arrow down" to="portfolio" spy={true} smooth={true} offset={50} duration={500}></Link>
            </div>
            <Portfolio />
            <Footer />
        </div>
        </Fade>
       );
    }
}
export default HomePage;
